import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";
// import {loaded} from "../global";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchBusiness = createAsyncThunk("fetchBusiness", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'business',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchBusiness.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchBusiness.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchBusiness.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
